import React, { Component } from 'react'
import './LoaderPage.css'

export default class LoaderPage extends Component {
  render() {
    return (
        <div className='d-flex justify-content-center align-items-center'>
          <div>
            <span className="loaderPage"></span>
            <span style={{marginTop:"30px"}} className="loaderPageSection"></span>
            <span className="loaderPageSection"></span>
            <span className="loaderPageSection"></span>
          </div>
        </div>
    )
  }
}